export const calculateQuantity = (bundle: any) =>
    bundle.products.reduce(
        (sum, { selectedColorsAndSizes }) =>
            sum + selectedColorsAndSizes.reduce((sum, { sizes }) => sum + sizes?.quantity || 0, 0),
        0,
    );
